export function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((reg) => {
          console.log("EarnMate SW registered:", reg.scope);

          // Check for updates every 60 seconds
          setInterval(() => reg.update(), 60000);

          reg.addEventListener("updatefound", () => {
            const newWorker = reg.installing;
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                console.log("New version available — reload to update");
              }
            });
          });
        })
        .catch((err) => console.error("SW registration failed:", err));
    });
  }
}